<template>
  <div>
    <b-overlay
      :show="show"
      no-wrap
      no-center
      variant="dark"
      opacity="0.15"
      z-index="1021"
      @click="closeActionSheet"
    >
      <template #overlay>
        <div
          :class="{
            actionList: true,
          }"
        >
          <ul class="actionListSection">
            <li
              v-for="action in actions"
              :key="action.message"
              class="action"
              @click="runAction(action.action)"
            >
              {{ action.message }}
            </li>
          </ul>
          <ul class="actionListSection">
            <li class="action" @click="closeActionSheet">キャンセル</li>
          </ul>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount, ref, watch, type PropType } from "vue";
import { useLegacyRootEvent } from "../../composables/useLegacyRootEvent";

type Action = {
  message: string;
  action: () => void;
};

export default defineComponent({
  props: {
    // storybook用
    externalActions: { type: Array as PropType<Action[]>, default: () => [] },
    // storybook用
    storybook: { type: Boolean, default: false },
  },
  setup(props) {
    const rootEvent = useLegacyRootEvent();

    const show = ref(false);
    const actions = ref<Action[]>([]);

    watch(
      () => props.externalActions,
      () => {
        actions.value.splice(0, actions.value.length);
        actions.value.push(...props.externalActions);
      },
      { immediate: true }
    );

    const closeActionSheet = (): void => {
      show.value = false;
    };

    const runAction = (action: () => void): void => {
      action();
      show.value = false;
    };

    // created 相当
    if (props.storybook) {
      show.value = true;
    }
    rootEvent.on("open-action-sheet", (actionList: Action[]) => {
      actions.value.splice(0, actions.value.length);
      actions.value.push(...actionList);
      show.value = true;
    });

    onBeforeUnmount(() => {
      rootEvent.off("open-action-sheet");
    });

    return { show, actions, closeActionSheet, runAction };
  },
});
</script>

<style lang="scss" scoped>
.actionList {
  width: 90vw;
  position: absolute;
  flex-direction: column;
  bottom: 10px;
  transform: translate(-50%, 0);
  -webkit-transform: translate(-50%, 0);
  left: 50%;
  font-weight: 400;

  .actionListSection {
    width: 100%;
    padding: 0;
    border-radius: 8px;
    background-color: white;
    margin-bottom: 8px;
    .action {
      cursor: pointer;
      width: 100%;
      height: 42px;
      color: #212529;
      border-bottom: solid;
      border-color: #dbdbdb;
      border-width: 1px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      &:last-child {
        border-bottom: none;
      }

      &:hover {
        background-color: rgb(200, 200, 200);
      }
    }
  }
}
</style>
